import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';

import { useDriversListQuery } from 'src/common/external/bambi-api/bambiApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { formatFullName } from 'src/common/util/formatFullName';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export function DriverSelectionField({
  onlySchedulable,
  fieldName = 'driver',
  disabled = false,
  onChange,
}: {
  onlySchedulable?: boolean;
  fieldName?: string;
  disabled?: boolean;
  onChange?: (value: SelectOption<string> | undefined) => void;
}) {
  const { data: drivers, isFetching } = useDriversListQuery({
    canBeScheduled: onlySchedulable,
  });
  return (
    <div>
      <FormFieldController
        name={fieldName}
        rules={{ required: 'Driver is required' }}
      >
        {({ field, fieldState }) => {
          return (
            <DefaultFormFieldLayout
              label="Driver *"
              error={fieldState.error?.message?.toString()}
              inputId="Driver-id"
            >
              <Select
                selected={field.value}
                options={
                  drivers?.results
                    ? drivers.results.map((driver) => {
                        return {
                          label:
                            formatFullName(driver) ||
                            `No name for driver id: ${driver.id}`,
                          value: driver.id,
                        };
                      })
                    : []
                }
                onChange={(selected) => {
                  field.onChange(selected);
                  onChange?.(selected);
                }}
                placeholder={
                  isFetching ? 'Loading drivers...' : 'Select a driver'
                }
                disabled={isFetching || disabled}
              />
            </DefaultFormFieldLayout>
          );
        }}
      </FormFieldController>
    </div>
  );
}
